export default __webpack_public_path__ + "4ecb077d8715f89c0f8700a9c8aca2c6.svg";